import { translate } from 'i18n/i18n'
import type { Moment } from 'moment-timezone'
import type { TProperty } from 'stores/fieldAssetStore/helperTypes'
import { makeNameEmitterTypeLabel } from 'utils/makeNameEmitterTypeLabel'
import { minutesToHoursAndMinutes } from 'utils/minutesToHoursAndMinutes'
import { removeCmOrInFromSoilProbeDepths } from 'utils/removeCmOrInFromSoilProbeDepths'
import { unitConverter } from 'utils/unitConverter/unitConverter'
import type { TIrrigationInterval } from './types'

export const SoilZoneHeader = ({
  title,
  soilStationFavoriteDepths,
  intervalsForChart,
  soilDateFrom,
  soilDateTo,
  selectedProperty,
}: {
  title: string
  soilStationFavoriteDepths: Array<string | number>
  intervalsForChart: TIrrigationInterval[]
  soilDateFrom: Moment
  soilDateTo: Moment
  selectedProperty: TProperty
}) => {
  return (
    <div>
      <div
        css={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 10,
          position: 'relative',
        }}
      >
        <div css={{ flex: '1 0 0' }}></div>
        <b
          css={{
            textDecoration: 'underline',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          {title}
        </b>
        <div>
          <div
            css={{
              flex: '1 0 0',
              textAlign: 'right',
              fontStyle: 'italic',
              fontSize: 13,
            }}
          >
            {`${translate.phrases.banyanApp('Root Zone Depths')} (${unitConverter
              .soilDepth()
              .suffix()}): [${soilStationFavoriteDepths
              .map((depth) =>
                unitConverter
                  .soilDepth(Math.abs(removeCmOrInFromSoilProbeDepths(String(depth))))
                  .valueAsString(),
              )
              .join(', ')}]`}
          </div>
          <div css={{ marginTop: 10 }}>
            {!!intervalsForChart?.length && (
              <div
                css={{
                  fontSize: 13,
                  marginBottom: 10,
                }}
              >
                <div
                  css={{
                    marginBottom: 5,
                    fontWeight: 'bold',
                    textDecoration: 'underline',
                  }}
                >{`${translate.dates.format(soilDateFrom, 'MMM D, YYYY')} - ${translate.dates.format(
                  soilDateTo,
                  'MMM D, YYYY h:mm a (z)',
                )}`}</div>
                {intervalsForChart.map((interval) => {
                  const { irrigationZoneEmitterId, emitterType, onDurationMinutes } = interval

                  return (
                    <div key={irrigationZoneEmitterId}>
                      {`${makeNameEmitterTypeLabel({
                        name: selectedProperty?.irrigationZoneEmitters?.[irrigationZoneEmitterId]?.name ?? '',
                        emitterType,
                      })}: ${minutesToHoursAndMinutes(onDurationMinutes)}`}
                    </div>
                  )
                })}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
